import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import React, { FC } from 'react';
import { SkeletonListItem } from './SkeletonListItem';
import { Props } from './types';

export const SkeletonList: FC<Props> = ({ selfPadding }) => (
  <FuelFlex
    testId="skeleton-list"
    defaultProps={{
      flexDirection: 'column',
      customPadding: selfPadding ? `0 ${dsTheme.spacing.km6} ${dsTheme.spacing.km6}` : `0`,
    }}
  >
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem />
    <SkeletonListItem showDivider={false} />
  </FuelFlex>
);
